import { URL } from "../../utils/UrlConstants";
import { privateFetch } from "../../utils/CustomFetch.js";
import { CONSTANT } from "../../utils/Constants";
import UrlBase from "../../url/Urls";
import {MeasureUnit} from "../../types/inventory/types";

export const getRequestUnit = async (data: any) => {
    let responseData = {};
    const requestBody = {
      filter: data.filter,
      page: data.page,
      size: data.size ?? UrlBase.registration_x_page,
    };
  
    await privateFetch
      .post(URL.REQUEST_UNIT_LIST, JSON.stringify(requestBody), {
        headers: {
          ...CONSTANT.HEADER_TYPE,
        },
      })
      .then(async (response) => {
        responseData = await response.data;
      })
      .catch(async (error) => {
        throw new Error("Error en consulta de Unidad de medida");
      });
  
    return responseData;
  };
  
export const findByIdRequest = async (id: any) => {
    let responseData = {};
    await privateFetch
      .get(URL.REQUEST_AUTHORITY(id), {})
      .then(async (response) => {
        responseData = await response.data;
      })
      .catch(async (error) => {
        throw new Error("Error en consulta de Unidad de medida por ID");
      });
    return responseData;
  };

export const createRequest = async (data: any) => {
  let responseData = {};
  const requestBody = {
    name: data.name,
    variants: data.variants,
    user: data.user,
      convertiable: data.convertiable,
  };

  await privateFetch
    .post(URL.REQUEST_UNIT, JSON.stringify(requestBody), {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error("Error en proceso de guardar Unidad de medida");
    });
  return responseData;
};

export const updateRequest = async (requestBody: any) => {
  let responseData = {};
  await privateFetch
    .put(URL.REQUEST_UNIT, JSON.stringify(requestBody), {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error("Error en proceso de actualizar Unidad de medida");
    });
  return responseData;
};

export const deleteRequest = async (id: any) => {
    let responseData = {};
    const requestBody = { id };
  
    await privateFetch
      .delete(URL.REQUEST_UNIT_DELETE, {
        data: requestBody,
        headers: {
          ...CONSTANT.HEADER_TYPE,
        },
      })
      .then(async (response) => {
        responseData = await response.data;
      })
      .catch((error) => {
        throw new Error("Error en proceso de eliminar Unidad de medida");
      });
  
    return responseData;
  };

  export const getRequestMeasureUnit = async () => {
    let responseData: MeasureUnit[] = [];
    await privateFetch
      .get(URL.REQUEST_UNIT_LIST_NAMES, {})
      .then(async (response) => {
        responseData = await response.data;
      })
      .catch(async (error) => {
        throw new Error("Error en consulta de nombres de Unidades de medida");
      });
    return responseData;
  };
